import clientYellowInstance from "@/lib/yellowClientInstance";

export default {
  namespaced: true,
  state() {
    return {
      user: {},
      categories: [],
      consultants: [],
      companies: [],
      banners: [],
      company: [],
      news: [],
    };
  },

  getters: {
    getUserInformation(state) {
      return state.user;
    },

    getAllCategories(state) {
      return state.categories;
    },

    getConsultantsByCategory(state) {
      return state.consultants;
    },

    getCompaniesByCategory(state) {
      return state.companies;
    },

    getBanners(state) {
      return state.banners;
    },

    getCompany(state) {
      return state.company;
    },

    getNews(state) {
      return state.news;
    },
  },

  mutations: {
    setUserInformation(state, payload) {
      state.user = payload;
    },

    setAllCategories(state, payload) {
      state.categories = payload;
    },

    setConsultantsByCategory(state, payload) {
      state.consultants = payload;
    },

    setCompaniesByCategory(state, payload) {
      state.companies = payload;
    },

    setBanners(state, payload) {
      state.banners = payload;
    },

    setCompany(state, payload) {
      state.company = payload;
    },

    setNews(state, payload) {
      state.news = payload;
    },
  },

  actions: {
    async fetchUserInformation({ commit }, payload) {
      try {
        const response = await clientYellowInstance.post(
          "/auth/login",
          payload
        );
        if (response.status === 200) {
          commit("setUserInformation", response.data.account);
          return response;
        }
      } catch (err) {
        return err;
      }
    },

    async fetchUserByToken({ commit }, token) {
      try {
        const response = await clientYellowInstance.get(
          `/get/user?token=${token}`
        );
        if (response.status === 200) {
          commit("setUserInformation", response.data.user);
          return response.data.user;
        }
      } catch (err) {
        console.error("Error fetching user by email:", err.message);
        return err;
      }
    },

    async fetchAllCategories({ commit }, lang) {
      try {
        const response = await clientYellowInstance.get(
          `/get/all-categories?lang=${lang}`
        );
        if (response.status === 200) {
          commit("setAllCategories", response.data.categories);
          return response;
        }
      } catch (err) {
        console.error("Error:", err.message);
        return err;
      }
    },

    async fetchConsultantsByCategory({ commit }, data) {
      const { lang, page, limit } = data;

      try {
        const response = await clientYellowInstance.get(
          `/get/consultants-by-category?lang=${lang}&page=${page}&limit=${limit}`
        );
        if (response.status === 200) {
          commit("setConsultantsByCategory", response.data);
          return response;
        }
      } catch (err) {
        console.error("Error:", err.message);
        return err;
      }
    },

    async fetchCompaniesByCategory({ commit }, data) {
      const { lang, category_code, page, limit } = data;

      try {
        const response = await clientYellowInstance.get(
          `/get/companies-by-category?lang=${lang}&category_code=${category_code}&page=${page}&limit=${limit}`
        );
        if (response.status === 200) {
          commit("setCompaniesByCategory", response.data);
          return response;
        }
      } catch (err) {
        console.error("Error:", err.message);
        return err;
      }
    },

    async searchConsultants({ commit }, data) {
      const { lang, page, limit, term } = data;

      try {
        const response = await clientYellowInstance.get(
          `/search/consultants?lang=${lang}&page=${page}&limit=${limit}&term=${term}`
        );
        if (response.status === 200) {
          commit("setConsultantsByCategory", response.data);
          return response;
        }
      } catch (err) {
        console.error("Error:", err.message);
        return err;
      }
    },

    async searchCompanies({ commit }, data) {
      const { lang, page, limit, term } = data;

      try {
        const response = await clientYellowInstance.get(
          `/search/companies?lang=${lang}&page=${page}&limit=${limit}&term=${term}`
        );
        if (response.status === 200) {
          commit("setCompaniesByCategory", response.data);
          return response;
        }
      } catch (err) {
        console.error("Error:", err.message);
        return err;
      }
    },

    async fetchBanners({ commit }) {
      try {
        const response = await clientYellowInstance.get(`/get/banners`);
        if (response.status === 200) {
          commit("setBanners", response.data.banners);
          return response;
        }
      } catch (err) {
        console.error("Error:", err.message);
        return err;
      }
    },

    async fetchCompany({ commit }, data) {
      const { lang, id } = data;

      try {
        const response = await clientYellowInstance.get(
          `/get/company?id=${id}&lang=${lang}`
        );
        if (response.status === 200) {
          commit("setCompany", response.data.company);
          return response;
        }
      } catch (err) {
        console.error("Error:", err.message);
        return err;
      }
    },

    async fetchNews({ commit }, lang) {
      try {
        const response = await clientYellowInstance.get(`/news?lang=${lang}`);
        if (response.status === 200) {
          commit("setNews", response.data.news);
          return response;
        }
      } catch (err) {
        console.error("Error:", err.message);
        return err;
      }
    },
  },
};
